
import { api, useApi } from "../../configuration/api/apiHelper";
import { UpdateUserCategoryRatesCommand, UserCategoryViewModel, GeneratePersonaInquiryResult } from "../../configuration/api/apiSchema";

// Select user categories
export enum SELECT_USER_CATEGORIES {
    REQUEST = "SELECT_USER_CATEGORIES_REQUEST",
    SUCCESS = "SELECT_USER_CATEGORIES_SUCCESS",
}

export const selectUserCategoriesRequestAction = () => {
    return {
        type: SELECT_USER_CATEGORIES.REQUEST
    };
};

export const selectUserCategoriesSuccessAction = () => {
    return {
        type: SELECT_USER_CATEGORIES.SUCCESS,
    };
};

export const selectUserCategories = (categoryKeys: string[]) => {
    return async (dispatch: any) => {
        dispatch(selectUserCategoriesRequestAction());

        const response = await useApi(() =>
            api.userOnboarding.selectCategoriesCreate({
                categoryKeys: categoryKeys
            }));

        if (response.result) {
            dispatch(selectUserCategoriesSuccessAction());
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

// Get user categories
export enum GET_USER_CATEGORIES {
    REQUEST = "GET_USER_CATEGORIES_REQUEST",
    SUCCESS = "GET_USER_CATEGORIES_SUCCESS",
}

export const getUserCategoriesRequestAction = () => {
    return {
        type: GET_USER_CATEGORIES.REQUEST
    };
};

export const getUserCategoriesSuccessAction = (userCategories: UserCategoryViewModel[]) => {
    return {
        type: GET_USER_CATEGORIES.SUCCESS,
        userCategories: userCategories
    };
};

export const getUserCategories = (userId?: string) => {
    return async (dispatch: any) => {
        dispatch(getUserCategoriesRequestAction());

        const response = await useApi(() =>
            api.categories.userSelectedList({
                userId: userId
            }));

        if (response.result) {
            dispatch(getUserCategoriesSuccessAction(response.result));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

export const openStripeOnboardingLink = () => {
    return async (dispatch: any) => {
      try {
        const rawResponse = await api.users.stripeOnboardingLinkList() as Response;
  
        // ✅ Parse the JSON body
        const data = await rawResponse.json();
  
        console.log("Parsed onboarding link response:", data);
  
        const link = data?.url;
  
        if (link && link.startsWith("https://connect.stripe.com")) {
          window.open(link, "_blank", "noopener,noreferrer");
        } else {
          console.error("Invalid onboarding URL:", data);
        }
      } catch (error) {
        console.error("Failed to open Stripe onboarding link:", error);
      }
    };
  };

// Update user category rates
export enum UPDATE_USER_CATEGORY_RATE {
    REQUEST = "UPDATE_USER_CATEGORY_RATE_REQUEST",
    SUCCESS = "UPDATE_USER_CATEGORY_RATE_SUCCESS",
}

export const updateUserCategoryRateRequestAction = () => {
    return {
        type: UPDATE_USER_CATEGORY_RATE.REQUEST
    };
};

export const updateUserCategoryRateSuccessAction = (updatedUserCategory: UserCategoryViewModel) => {
    return {
        type: UPDATE_USER_CATEGORY_RATE.SUCCESS,
        updatedUserCategory: updatedUserCategory
    };
};

export const updateUserCategoryRate = (userCategory: UserCategoryViewModel) => {
    return async (dispatch: any) => {
        dispatch(updateUserCategoryRateRequestAction());

        const command = {
            categoryKey: userCategory.key,
            fixedPriceRate: userCategory.fixedPriceRate,
            fixedPriceRateCurrencyKey: userCategory.fixedPriceRateCurrencyKey,
            hourlyRate: userCategory.hourlyRate,
            hourlyRateCurrencyKey: userCategory.hourlyRateCurrencyKey
        } as UpdateUserCategoryRatesCommand;

        const response = await useApi(() =>
            api.categories.categoriesUpdate(command));

        if (!response.error) {
            dispatch(updateUserCategoryRateSuccessAction(userCategory));
        }
        else {
            // TODO: error
            // dispatch(throwError(response.toString()));
        }
    };
};

export enum START_USER_KYC {
  REQUEST = "START_USER_KYC_REQUEST",
  SUCCESS = "START_USER_KYC_SUCCESS",
  FAILURE = "START_USER_KYC_FAILURE",
}

const startUserKycRequestAction = () => ({ type: START_USER_KYC.REQUEST });
const startUserKycSuccessAction = (payload: GeneratePersonaInquiryResult) => ({
  type: START_USER_KYC.SUCCESS,
  payload,
});
const startUserKycFailureAction = (message: string) => ({
  type: START_USER_KYC.FAILURE,
  message,
});

// ── 2. thunk ──────────────────────────────────────────────────
export const startUserKyc = () => {
  return async (dispatch: any) => {
    dispatch(startUserKycRequestAction());

    try {
      const raw: Response = await api.user.verificationPersonaStartCreate({
        format: undefined as any,   // disable auto-json
      });

      // ---- 404 – do nothing ----------------------------------
      if (raw.status === 404) {
        dispatch(startUserKycFailureAction("endpoint not found"));
        return null;
      }

      // ---- other non-success ---------------------------------
      if (!raw.ok) {
        const errText = await raw.text();          // may be empty
        dispatch(startUserKycFailureAction(errText || raw.statusText));
        return null;                               // ⬅️  don’t throw
      }

      // ---- happy path ----------------------------------------
      const data: GeneratePersonaInquiryResult = await raw.json();
      dispatch(startUserKycSuccessAction(data));
      return data;

    } catch (e: any) {
      // network / CORS, etc. – still swallow
      dispatch(startUserKycFailureAction(e?.message ?? "network error"));
      return null;                                 // ⬅️  don’t throw
    }
  };
};
